module.exports = "fragment Region on RegionType{__typename id name code old}"